import React, { useEffect, useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import CheerOverlayLayer from "../components/CheerOverlayLayer";

const ALERT_VARIANTS = [
  "power-meter",
  "combo-breaker",
  "loot-drop",
  "hype-portal",
  // Legacy style names still accepted so old OBS URLs do not break.
  "impact",
  "arcade",
  "spotlight",
  "comic",
];

function useTransparentBody() {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    const prev = {
      htmlBg: html.style.background,
      htmlBgImg: html.style.backgroundImage,
      bodyBg: body.style.background,
      bodyBgImg: body.style.backgroundImage,
      bodyMargin: body.style.margin,
      bodyOverflow: body.style.overflow,
    };

    html.style.background = "transparent";
    html.style.backgroundImage = "none";
    body.style.background = "transparent";
    body.style.backgroundImage = "none";
    body.style.margin = "0";
    body.style.overflow = "hidden";

    return () => {
      html.style.background = prev.htmlBg;
      html.style.backgroundImage = prev.htmlBgImg;
      body.style.background = prev.bodyBg;
      body.style.backgroundImage = prev.bodyBgImg;
      body.style.margin = prev.bodyMargin;
      body.style.overflow = prev.bodyOverflow;
    };
  }, []);
}

function clamp(n, min, max) {
  return Math.max(min, Math.min(max, n));
}

export default function OverlayCheers() {
  const { channelId } = useParams();
  const [sp] = useSearchParams();

  useTransparentBody();

  const forcedVariant = useMemo(() => {
    const raw = String(sp.get("style") || "").trim().toLowerCase();
    return ALERT_VARIANTS.includes(raw) ? raw : "";
  }, [sp]);

  const showDebug = sp.get("debug") === "1";
  const showMeta = sp.get("meta") === "1";

  const scale = clamp(Number(sp.get("scale") || 1), 0.7, 1.6);
  const top = clamp(Number(sp.get("top") || 7), 0, 70);
  const left = clamp(Number(sp.get("left") || 50), 0, 100);

  const videoScale = clamp(Number(sp.get("videoScale") || 1), 0.5, 2.2);
  const videoTop = clamp(Number(sp.get("videoTop") || 50), 0, 100);
  const videoLeft = clamp(Number(sp.get("videoLeft") || 50), 0, 100);
  const videoWidth = clamp(Number(sp.get("videoWidth") || 34), 12, 90);

  return (
    <CheerOverlayLayer
      channelId={channelId}
      forcedVariant={forcedVariant}
      showDebug={showDebug}
      showMeta={showMeta}
      mode="overlay"
      scale={scale}
      top={top}
      left={left}
      videoScale={videoScale}
      videoTop={videoTop}
      videoLeft={videoLeft}
      videoWidth={videoWidth}
    />
  );
}
